import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { get } from "@rails/request.js"
import { restartCssAnimations } from "../utils/restart_css_animations"

// Opens associate / attach picker modals with an immediate loading shell
// (same spinner as #taskModal), then loads the real dialog.
//
// kind (data-associate-modal-kind-param):
//   "turbo-stream" (default) — GET + Turbo.renderStreamMessage (people/company associate)
//   "turbo-frame"            — Turbo.visit into #modal (attach existing task, …)
export default class extends Controller {
  async open(event) {
    event.preventDefault()

    const url = event.currentTarget.href
    if (!url) return

    this._showLoadingModal()

    const kind = event.params.kind || "turbo-stream"

    if (kind === "turbo-frame") {
      try {
        await Turbo.visit(url, { frame: "modal" })
      } catch {
        this._resetModalFrame()
      }
      return
    }

    try {
      const response = await get(url, { responseKind: "turbo-stream" })
      if (response.ok) {
        Turbo.renderStreamMessage(await response.text())
      } else {
        this._resetModalFrame()
      }
    } catch {
      this._resetModalFrame()
    }
  }

  _showLoadingModal() {
    const frame = document.getElementById("modal")
    const template = document.getElementById("associate-modal-loading-template")
    if (!frame || !template) return

    this._resetModalFrame()
    frame.innerHTML = template.innerHTML

    // modal_controller#connect will show the dialog; also restart after paint in
    // case shown.bs.modal already fired before our listener attached.
    requestAnimationFrame(() => {
      const modalEl = frame.querySelector(".modal")
      if (!modalEl) return
      const restart = () => restartCssAnimations(modalEl)
      if (modalEl.classList.contains("show")) {
        restart()
      } else {
        modalEl.addEventListener("shown.bs.modal", restart, { once: true })
      }
    })
  }

  _resetModalFrame() {
    const frame = document.getElementById("modal")
    if (!frame) return

    frame.querySelectorAll(".modal").forEach((modalEl) => {
      const instance = Modal.getInstance(modalEl)
      if (instance) {
        instance.hide()
        instance.dispose()
      }
    })

    frame.innerHTML = ""
    this._cleanupModalBodyState()
  }

  _cleanupModalBodyState() {
    // Nested under #taskModal (or another open dialog): keep body lock + backdrop.
    if (document.querySelector(".modal.show")) return
    if (!document.body.classList.contains("modal-open")) return

    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
  }
}
